import { createContext, useContext, useState } from "react"

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [showActiveServices, setShowActiveServices] = useState(false);
    const [showPastServices, setShowPastServices] = useState(false);
    const [activeServiceData, setActiveServiceData] = useState([]);
    const [pastServiceData, setPastServiceData] = useState([]);

    const handleShowActiveServices = () => {
        setShowActiveServices(!showActiveServices);
        setShowPastServices(false);
    }

    const handleShowPastServices = () => {
        setShowPastServices(!showPastServices);
        setShowActiveServices(false);
    }

    const closeServiceTable = () => {
        setShowActiveServices(false);
        setShowPastServices(false);
    }

    return(
        <AppContext.Provider value={{showActiveServices, handleShowActiveServices, showPastServices, handleShowPastServices, activeServiceData, setActiveServiceData , pastServiceData, setPastServiceData, closeServiceTable}} >
            {children}
        </AppContext.Provider>
    )
}

export const useGlobalAppContext = () => {
    return useContext(AppContext);
}